module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4_1536.b7f1b054.jpg";